<template>
  <div class="intelligentAgriculture-page">
    <!-- 智慧农业 -->
    <div class="haeder-container blackStatic">
      <Header></Header>
      <Nav></Nav>
    </div>
    <div class="content-box">
      <img src="../../assets/img/bug/bug01.jpg" alt />
      <img src="../../assets/img/bug/bug02.jpg" alt />
      <img src="../../assets/img/bug/bug03.jpg" alt />
      <img src="../../assets/img/bug/bug04.jpg" alt />
      <img src="../../assets/img/bug/bug05.jpg" alt />
      <img src="../../assets/img/bug/bug06.jpg" alt />
    </div>
    <Foot></Foot>
  </div>
</template>
<script>
import Header from "@/components/Header";
import Nav from "@/components/Nav";
import Foot from "@/components/Foot";

export default {
  name: "pestMonitoring",
  components: {
    Header,
    Nav,
    Foot,
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {},
};
</script>
<style scoped>
.content-box {
  width: 100%;
  min-height: 800px;
}
.content-box img {
  width: 100%;
  height: auto;
}
</style>